import React from 'react'

const PreviousQuestion = ({prev, index}) => (
    <div className="xmp-question">
      <span>{ prev.title }<a className={"xmp-privacy-select" + prev.privacy} data-options="align:bottom" data-dropdown={'test-drop'+index} aria-controls={'test-drop'+index}></a>
        <ul id={'test-drop'+index} className="f-dropdown" data-dropdown-content aria-hidden="true" tabIndex="-1">
          {(prev.privacy == 'private') ?
            <li><a href="#" className="xmp-private">Private</a></li> :
            <li><a href="#" className="xmp-shared">Shared with members</a></li>
          }
        </ul>
      </span>
    </div>
)


export default PreviousQuestion



// WEBPACK FOOTER //
// ./src/components/PreviousQuestion.js